import { Skeleton } from "@/components/ui/skeleton";

export const HeaderProfileBlockSkeleton = () => {
  return (
    <div className="flex items-center space-x-4">
      <div className="flex w-[220px] items-center gap-2 rounded-md border p-2">
        {/* Скелетон для аватара */}
        <Skeleton className="h-8 w-8 rounded-full" />
        {/* Скелетон для текста */}
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-[140px]" />
        </div>
        {/* Скелетон для стрелки */}
        <Skeleton className="h-4 w-4" />
      </div>
    </div>
  );
};
